import { useState } from "react";
import { Form, Button, Input, Select } from "antd";

const CRON = "CRON"
const FIXED_RATE = "FIXED_RATE"

export default function EditJob({
    initialValues,
    onSubmit,
    submitting
}: {
    initialValues?: Partial<JobRecord>,
    onSubmit: (values: Partial<JobRecord>) => void,
    submitting?: boolean
}) {
    const [form] = Form.useForm();
    const [isCron, setIsCron] = useState(initialValues?.type === CRON);
    const [isFixedRate, setIsFixedRate] = useState(initialValues?.type === FIXED_RATE);
    return (
        <Form
            form={form}
            labelCol={{
                span: 6
            }}
            wrapperCol={{
                span: 18
            }}
            initialValues={initialValues}
        >
            <Form.Item name='jobName' label='任务名称' rules={[{ required: true }]}>
                <Input />
            </Form.Item>
            <Form.Item name='type' label='任务类型' rules={[{ required: isCron }]}>
                <Select onChange={value => {
                    setIsCron(value === CRON)
                    setIsFixedRate(value === FIXED_RATE)
                }} options={[
                    { label: CRON, value: CRON },
                    { label: FIXED_RATE, value: FIXED_RATE },
                ]} />
            </Form.Item>
            {
                isCron &&
                <Form.Item name='cron' label='CRON表达式' rules={[{ required: isCron }]}>
                    <Input />
                </Form.Item>
            }
            {
                isFixedRate &&
                <Form.Item name='interval' label='间隔时间' rules={[{ required: isFixedRate }]}>
                    <Input type="number" />
                </Form.Item>
            }
            <Form.Item name='triggerName' label='触发器' rules={[{ required: true }]}>
                <Input />
            </Form.Item>
            <Form.Item>
                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end'
                }}>
                    <Button loading={submitting} htmlType="button" type='primary' onClick={() => {
                        form.validateFields()
                            .then(values => {
                                onSubmit(values)
                            }).catch(() => { })
                    }}>提交</Button>
                </div>
            </Form.Item>
        </Form>
    )
}